export default "<ion-app>\r\n  <app-side-menu></app-side-menu>\r\n\r\n</ion-app>\r\n";